
import { Component, Vue } from 'vue-property-decorator'
import CompanyDetail from '@/components/company/CompanyDetail.vue'
import authModule from '@/store/auth'

@Component({
  name: 'Company',
  components: { CompanyDetail }
})
class Company extends Vue {
  private created(): void {
    if (!(authModule.isSuperadmin || authModule.isAdmin)) {
      this.$router.replace({ name: 'Home' })
    }
  }
}

export default Company
